import React from 'react'
import cer1 from './image/cer1.jpeg'
import cer2 from './image/cer2.jpg'
import cer3 from './image/cer3.jpg'
function Certificates() {
  return (
    <div>
      <div className='container py-4 d-sm-block d-md-none'>
        <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-5 pb-2'>Certificates</h1>
                <p className='fs-6'>Prove Your Knowledge with Our Highly Esteemed Certifications, valued in All Professions.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>

        <div className='row pt-3'>
            <div className='col-md-4'>
                <div className='p-3'>
                    <img className='mobile_Certificates_img shadow'  src={cer1}></img>
                </div>
            </div>
            <div className='col-md-4'>
                <div className='p-3'>
                <img className='mobile_Certificates_img shadow'  src={cer2}></img>
                </div>
            </div>
            <div className='col-md-4'>
                <div className='p-3'>
                <img className='mobile_Certificates_img shadow'  src={cer3}></img>
                </div>
            </div>
        </div>
      </div>

      <div className='container py-5 d-none d-md-block'>
        <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-4 pb-2'>Certificates</h1>
                <p className='fs-5'>Prove Your Knowledge with Our Highly Esteemed Certifications, valued in All Professions.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>

        <div className='row mt-4'>
            <div className='col-4'>
                <img className='Certificates shadow' src={cer1}></img>
            </div>
            <div className='col-4'>
                <img className='Certificates shadow' src={cer2}></img>
            </div>
            <div className='col-4'>
                <img className='Certificates shadow' src={cer3}></img>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Certificates
